import { render, staticRenderFns } from "./personal-data.vue?vue&type=template&id=2544f98a&"
import script from "./personal-data.component.ts?vue&type=script&lang=ts&"
export * from "./personal-data.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports